import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { ADD_SUB_ACTION_LABEL } from 'src/presentation/components/pages/sidekick/threads/SidekickConstants';
import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import DropdownMenu from '@ad-scripts/presentation/components/common/dropdown_menu_v2';
import FormContext from 'src/presentation/contexts/FormContext';
import {
  selectCurrentAnonModule,
  selectCurrentModule,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import SidekickModuleSpec from 'src/models/Sidekick/SidekickModuleSpec';
import { SidekickThreadEditorContext } from 'src/presentation/components/pages/sidekick/threads/SidekickThreadEditorContext';
import { StyledAddModuleContainer } from 'src/presentation/components/pages/sidekick/threads/components/AddModule';
import { ThreadModuleContext } from './ThreadModuleContext';
import useAddModifier from 'src/presentation/components/pages/sidekick/threads/hooks/useAddModifier';

const AddSubActionButton = () => {
  const { readOnly } = useContext(SidekickThreadEditorContext);
  const { moduleSpecsMap } = useContext(ThreadModuleContext);

  let currentModule = useSelector(selectCurrentModule);
  const anonModule = useSelector(selectCurrentAnonModule);

  if (anonModule) {
    currentModule = anonModule;
  }

  const { workingState } = useContext(FormContext);

  const moduleId = currentModule?.id;
  const moduleSpec = moduleSpecsMap[(workingState as SidekickModuleSpec).name];

  const { hasModifiers, options, handleAddModifier } = useAddModifier({
    moduleId,
    moduleSpec,
    readOnly,
  });

  if (!hasModifiers) {
    return null;
  }

  return (
    <StyedDropdownMenu
      options={options}
      className="add-sub-action-button"
      fitOpenerWidth={false}
      onSelect={handleAddModifier}
      renderCustomOpener={({ setTargetRef, onToggle }) => {
        const handleToggle = e => {
          e.stopPropagation();
          onToggle(e);
        };
        return (
          <StyledAddModuleContainer disabled={readOnly} ref={setTargetRef} onClick={handleToggle}>
            <Button type={ButtonTypes.OUTLINE} disabled={readOnly} onClick={e => e.preventDefault()}>
              {ADD_SUB_ACTION_LABEL}
            </Button>
          </StyledAddModuleContainer>
        );
      }}
    />
  );
};

const StyedDropdownMenu = styled(DropdownMenu)`
  min-width: 200px;
`;

export default AddSubActionButton;
